import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const updateProfileWorkBeforeSlice = createSlice({
  name: "updateProfileWorkBefore",
  initialState,
  reducers: {
    updateProfileWorkBeforeStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    updateProfileWorkBeforeSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    updateProfileWorkBeforeFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetProfileWorkBefore: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateProfileWorkBeforeStart,
  updateProfileWorkBeforeSuccess,
  updateProfileWorkBeforeFailed,
  resetProfileWorkBefore,
} = updateProfileWorkBeforeSlice.actions;

export default updateProfileWorkBeforeSlice.reducer;
